import { legacyPath, slugFromPathname } from "../tenant-paths.ts";

export type StartupRoute = { kind: "legacy" } | { kind: "root" } | { kind: "connection-test" } | { kind: "tenant"; slug: string };

const CONNECTION_TEST_PATH = "/connection-test";

export const classifyPath = (pathname: string): StartupRoute => {
  if (pathname === CONNECTION_TEST_PATH) return { kind: "connection-test" };
  if (legacyPath(pathname, "-") !== null) return { kind: "legacy" };
  const slug = slugFromPathname(pathname);
  return slug ? { kind: "tenant", slug } : { kind: "root" };
};

// Where to send a slug-less SPA path once the internal tenant slug is known.
export const legacyRedirectTarget = (location: { pathname: string; search: string; hash: string }, internalSlug: string): string | null => {
  const path = legacyPath(location.pathname, internalSlug);
  return path === null ? null : `${path}${location.search}${location.hash}`;
};

// Which route tree to build from the session probe. 401 and 403 mean there is no usable session (the gate will sign in or explain);
// any other failure is unknown, so the caller must retry rather than guess a tree.
export const treeKindForProbe = (probe: { kind: "external" | "internal" } | { status: number | null }): "external" | "internal" | null => {
  if ("kind" in probe) return probe.kind;
  return probe.status === 401 || probe.status === 403 ? "internal" : null;
};
